import React from 'react';
import { 
  createBrowserRouter, 
  RouterProvider, 
  Navigate,
  createRoutesFromElements,
  Route
} from 'react-router-dom';
import PrivateRoute from './components/shared/PrivateRoute';
import Layout from './components/shared/Layout';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import Dashboard from './components/dashboard/Dashboard';
import Inventory from './components/inventory/Inventory';
import Statistics from './components/statistics/Statistics';
import Settings from './components/settings/Settings';
import Tools from './components/tools/Tools';
import RepairCalcApp from './components/tools/repaircalc/RepairCalcApp';
import AdminPage from './pages/AdminPage';
import { AuthProvider } from './contexts/AuthContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import { LanguageProvider } from './contexts/LanguageContext';

function App() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/inventory"
          element={
            <PrivateRoute>
              <Layout>
                <Inventory />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/statistics"
          element={
            <PrivateRoute>
              <Layout>
                <Statistics />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/tools"
          element={
            <PrivateRoute>
              <Layout>
                <Tools />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/preventivo"
          element={
            <PrivateRoute>
              <Layout>
                <RepairCalcApp />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <Layout>
                <Settings />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <Layout>
                <AdminPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </>
    ),
    {
      future: {
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }
    }
  );

  return (
    <AuthProvider>
      <LanguageProvider>
        <SubscriptionProvider>
          <RouterProvider 
            router={router} 
            future={{
              v7_startTransition: true
            }}
          />
        </SubscriptionProvider>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;